import { isMobileOnly } from 'react-device-detect';
import { COLORS, colors } from '@constants/colors';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  return {
    input: {
      color: COLORS.WHITE,
      padding: isMobileOnly ? '11px 0 15px 0' : '12px 0 16px 0',
      fontSize: '14px',
      height: '14px',
      lineHeight: 1,
      columnGap: 1,
      borderRadius: '0',
      borderBottom: 'solid 1px ' + colors.grey_200,
      background: 'none',
      marginBottom: 2,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        marginBottom: 1.5,
      },
      svg: {
        path: {
          fill: colors.grey_200,
        },
      },
      '&.Mui-focused': {
        borderBottom: 'solid 1px ' + colors.white,
        'svg:first-of-type': {
          path: {
            fill: colors.white,
          },
        },
        '&:not(.Mui-disabled)::before': {
          borderBottom: 'none',
        },
      },
      '&::before': {
        content: "''",
        transition: 'none',
        display: 'none',
      },
      '&::after': {
        borderBottom: 'none',
      },
      '& input': {
        color: COLORS.WHITE,
        '&::placeholder': {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 1.43,
          letterSpacing: '0.25px',
          color: COLORS.WHITE_6,
          opacity: 1,
        },
      },
    },
    clearIcon: {
      fontSize: 16,
      width: 24,
      height: 32,
      color: COLORS.MEDIUM_GREY,
      cursor: 'pointer',
      '&:hover': {
        color: COLORS.WHITE,
      },
    },
  };
};
